import React, { useEffect, useState } from 'react';
import { intervalToDuration } from 'date-fns';
import { pad } from 'shared/utils/pad';

const ElapsedTime = ({ startTime }: { startTime: Date | null }): JSX.Element => {
  const [elapsedTime, setElapsedTime] = useState('00:00');

  useEffect(() => {
    const interval = setInterval(() => {
      const start = startTime ?? new Date();
      const { hours, minutes, seconds } = intervalToDuration({
        start,
        end: new Date(),
      });
      setElapsedTime(`${hours ?? 0 > 0 ? `${pad(hours ?? 0)}:` : ''}${pad(minutes ?? 0)}:${pad(seconds ?? 0)}`);
    }, 1000);
    return (): void => clearInterval(interval);
  }, [startTime]);

  return <>{elapsedTime}</>;
};

export default ElapsedTime;
